<template>
    <modal title="Umsatzdetails">
        <ion-grid class="ion-margin-bottom">
            <ion-row>
                <ion-col>
                    <b>Text</b><br />
                    {{ transaction.BookingText }}
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col>
                    <b>Betrag</b><br />
                    <span
                        :class="{
                            'u-color-red': transaction.Amount.startsWith('-'),
                        }"
                        >{{ transaction.Amount | currency }}</span
                    >
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col size="6">
                    <b>Buchung am</b><br />
                    {{ formatDate(transaction.BookingDate.substring(0, 10)) }}
                </ion-col>
                <ion-col size="6">
                    <b>Valuta</b><br />
                    {{ formatDate(transaction.ValueDate.substring(0, 10)) }}
                </ion-col>
            </ion-row>
        </ion-grid>
        <template v-slot:footer>
            <ion-button expand="block" @click="$ionic.modalController.dismiss()"
                >Schließen</ion-button
            >
        </template>
    </modal>
</template>

<script>
import Modal from "./Modal";
import { DateFormatter } from "@/utils/date";

export default {
    components: {
        Modal,
    },
    props: {
        transaction: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {};
    },
    methods: {
        formatDate(dateString) {
            return DateFormatter.formatDate(new Date(dateString), "DD.MM.YYYY");
        },
    },
};
</script>

<style></style>
